<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-08-05 16:49:25
 * @最后编辑: Betway
 * @最后修改时间: 2022-09-26 11:01:59
-->
<template>
  <div>
    <slot name="tirgger">
      <mrc_ess_input
        @click="!readonly && openDialog()"
        :background-color="readonly ? '' : '#f5f5f5'"
        :placeholder="label"
        :value="uuid ? returnText(viewAllList) : returnText(addViewList)"
        :readonly="true"
        :label="label"
      >
      </mrc_ess_input>
    </slot>
    <!-- <v-btn width="30"
           @click="!readonly&&openDialog()">
      <span style="position:absolute;top:22px;left:7px;">选人员</span>
      <v-text-field v-model="uuid"
                    style="width:60px;opacity: 0;"
                    :readonly='true'
                    :label="label"></v-text-field>
    </v-btn> -->
    <!-- 提交之后展示  -->
    <!-- 修改 -->
    <!-- <slot :item='viewAllList'
          v-if="uuid">
      <div>
        <div v-for="(item,index) in viewAllList"
             class="my-1"
             :key="index">
          {{item.organization_names}}
        </div>
      </div>
    </slot> -->
    <!-- 新增 -->
    <!-- <slot :item='addViewList'
          v-else>
      <div>
        <div v-for="(item,index) in addViewList"
             class="my-1"
             :key="index">
          {{item.organization_names}}
        </div>
      </div>
    </slot> -->
    <mrc_ess_myDialog
      :title="$t('label_chooseStaff-selectStaff-Title')"
      @flag="flag"
      width="900"
      v-model="dialog"
      :disabled="true"
      :noPadding="false"
      @cancel="cancel"
      @success="success"
    >
      <div class="d-flex" style="background-color: #ffffff">
        <div style="flex: 1 1" class="dv">
          <v-tabs
            v-model="tabs"
            background-color="#ffffff"
            grow
            active-class="tabactive"
            slider-size="50"
            :hide-slider="true"
            dark
            @change="changeTabs"
            color="primary"
          >
            <v-tab v-for="item in items" :key="item" class="text-capitalize">
              {{ $t(item) }}
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tabs">
            <v-tab-item>
              <mrc_ess_selectStaff
                :allList="treeList"
                :item-text="itemText"
                :item-key="itemKey"
                :staffList="staffList"
                :cardLoading="cardLoading"
                @detailStaff="detailStaff"
                @selectAll="selectAll"
                @getStaffList="getStaffList"
              >
              </mrc_ess_selectStaff>
            </v-tab-item>
            <v-tab-item>
              <mrc_ess_chooseTree
                v-model="orgTreeList"
                :item-text="itemText"
                :cardLoading="cardLoading"
                :item-key="itemKey"
                ref="treeRef"
                maxHeight="411"
                @changeAllList="changeAllList"
                @getDetail="getDetail"
              ></mrc_ess_chooseTree>
            </v-tab-item>
            <v-tab-item>
              <mrc_ess_selectStaff
                :allList="treeList"
                :item-text="itemText"
                :item-key="itemKey"
                :staffList="positionList"
                :cardLoading="cardLoading"
                @detailStaff="detailStaff"
                @selectAll="selectAll"
                @getStaffList="getStaffList"
              >
                <template #default="{ item }">
                  <div
                    class="d-flex justify-space-between align-center"
                    style="width: 100%"
                  >
                    <span
                      :style="{
                        color: item.active ? '#0F46C1' : 'rgba(0, 0, 0, 0.78)',
                        'font-size': '14px',
                      }"
                    >
                      {{ INT(item.job_post_name) }}
                    </span>
                    <span v-if="item.active">
                      <v-icon
                        class="material-icons mr-3"
                        v-if="item.active"
                        style="color: rgb(19, 166, 113)"
                      >
                        check_circle
                      </v-icon>
                    </span>
                    <span v-else></span>
                  </div>
                </template>
              </mrc_ess_selectStaff>
            </v-tab-item>
            <v-tab-item>
              <mrc_ess_sclectStaffGroup
                @selectAll="selectAll"
                ref="groupRef"
                :cardLoading="cardLoading"
                :delCardLoading="delCardLoading"
                @deleteGroup="deleteGroup"
                @findDetail="findDetail"
                @detailStaff="detailStaff"
                v-model="groupList"
              ></mrc_ess_sclectStaffGroup>
            </v-tab-item>
          </v-tabs-items>
        </div>
        <!-- ----------- -->
        <div class="segmentation2"></div>
        <!-- -------------- -->
        <div style="flex: 1 1; max-width: 338px" v-if="!loading">
          <div v-if="!findGroupStatus" class="pr-4 pt-3 pl-4">
            <div class="d-flex justify-space-between mb-3">
              <div>
                <v-icon
                  class="material-icons"
                  :style="{
                    color: allListLength > 0 ? 'rgb(19, 166, 113)' : '',
                    'font-size': '20px',
                  }"
                >
                  check_circle
                </v-icon>
                <span
                  class="ml-2"
                  :style="{
                    'font-size': '12px',
                    color:
                      allListLength > 0 ? '#0f46c1' : 'rgba(0, 0, 0, 0.38)',
                  }"
                  >{{
                    $t("label_chooseStaff-selected", { number: allListLength })
                  }}</span
                >
              </div>
              <div @click="saveGroup" class="gesture">
                <v-icon
                  class="material-icons"
                  :style="{
                    color:
                      !allListLength > 0 ? 'rgba(0, 0, 0, 0.38)' : '#0f46c1',
                    'font-size': '20px',
                  }"
                >
                  save
                </v-icon>
                <span
                  class="ml-2"
                  :style="{
                    color:
                      !allListLength > 0 ? 'rgba(0, 0, 0, 0.38)' : '#0f46c1',
                    'font-size': '12px',
                  }"
                  >{{ $t("label_chooseStaff-saveAsGroup") }}</span
                >
              </div>
            </div>
            <div class="pt-2 pb-2" style="border: 1px solid #ececec">
              <div class="footer_box pl-3 pr-2">
                <!-- 员工-->
                <div
                  style="
                    font-family: var(--body-font-family);
                    font-style: normal;
                    font-weight: normal;
                    line-height: 128.91%;
                    display: flex;
                    align-items: center;
                    color: rgba(0, 0, 0, 0.38);
                    flex: none;
                    order: 4;
                    align-self: center;
                    font-size: 12px;
                  "
                  class="py-2"
                  v-if="checkedStaffList.length > 0"
                >
                  {{ $t("label_chooseStaff-tab-Staffs") }}
                </div>
                <div
                  class="d-flex mt-1 pl-2 gesture"
                  v-for="(item, index) in checkedStaffList"
                  :key="item + index"
                  @click.stop="tabs == 0 ? deleteItem(item, index) : ''"
                  style="
                    border: 1px solid #ececec;
                    height: 48px;
                    font-size: 14px;
                    border-radius: 4px;
                  "
                  :class="item.active ? 'active' : ''"
                >
                  <div class="ml-2 mt-1">
                    <v-img
                      style="border-radius: 50%"
                      height="24"
                      width="24"
                      :src="`https://picsum.photos/500/300?image=${5 * 5 + 10}`"
                      :lazy-src="`https://picsum.photos/10/6?image=${
                        5 * 5 + 10
                      }`"
                      class="grey lighten-2"
                    ></v-img>
                  </div>
                  <div class="d-flex ml-2" style="flex-direction: column">
                    <span
                      :style="{
                        color: item.active ? '#0F46C1' : 'rgba(0, 0, 0, 0.78)',
                        'font-size': '14px',
                      }"
                    >
                      <!-- ' \xa0 ' -->
                      {{ item.christian_name ? item.christian_name : "" }}
                      {{ item.christian_name && item.show_name ? "/" : "" }}
                      {{
                        item.show_name ? INT(item.show_name) : item.show_name
                      }}
                    </span>
                    <span
                      :style="{
                        color: item.active ? '#739CE8' : 'rgba(0, 0, 0, 0.38)',
                        'font-size': '12px',
                      }"
                    >
                      {{ INT(item.job_post_name) }}
                    </span>
                  </div>
                </div>
                <!-- 组织架构 -->
                <div
                  style="
                    font-family: var(--body-font-family);
                    font-style: normal;
                    font-weight: normal;
                    line-height: 128.91%;
                    display: flex;
                    align-items: center;
                    color: rgba(0, 0, 0, 0.38);
                    flex: none;
                    order: 4;
                    align-self: center;
                    font-size: 12px;
                  "
                  class="py-2"
                  v-if="checkedOrgList.length > 0"
                >
                  {{ $t("label_chooseStaff-tab-Organization") }}
                </div>
                <div
                  class="d-flex mt-1 pl-2 align-center gesture"
                  v-for="(item, index) in checkedOrgList"
                  :key="item.uuid + index"
                  @click.stop="tabs == 1 ? deleteItem(item, index) : ''"
                  style="
                    border: 1px solid #ececec;
                    height: 48px;
                    font-size: 14px;
                    border-radius: 4px;
                  "
                  :class="item.active ? 'active' : ''"
                >
                  <div class="d-flex flex-column">
                    <span style="font-size: 14px; color: #0f46c1">
                      {{ INT(item.org_level_name) }}</span
                    >
                    <span
                      style="
                        font-size: 10px;
                        color: rgba(0, 0, 0, 0.38);
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        max-width: 250px;
                      "
                    >
                      {{ INT(item.org_level_all) }}</span
                    >
                  </div>
                </div>
                <!-- 岗位列表 -->
                <div
                  style="
                    font-family: var(--body-font-family);
                    font-style: normal;
                    font-weight: normal;
                    font-size: 12px;
                    display: flex;
                    align-items: center;
                    color: rgba(0, 0, 0, 0.38);
                    flex: none;
                    order: 4;
                    align-self: center;
                  "
                  class="py-2"
                  v-if="checkedPositionList.length > 0"
                >
                  {{ $t("label_chooseStaff-tab-Position") }}
                </div>
                <div
                  class="d-flex mt-1 pl-2 pt-1 flex-column gesture"
                  v-for="(item, index) in checkedPositionList"
                  :key="item.uuid + index"
                  @click.stop="tabs == 2 ? deleteItem(item, index) : ''"
                  style="
                    border: 1px solid #ececec;
                    height: 48px;
                    font-size: 14px;
                    border-radius: 4px;
                  "
                  :class="item.active ? 'active' : ''"
                >
                  <span
                    :style="{
                      color: item.active ? '#0F46C1' : 'rgba(0, 0, 0, 0.78)',
                      'font-size': '14px',
                    }"
                    >{{ INT(item.job_post_name) }}</span
                  >
                  <span
                    :style="{
                      color: item.active
                        ? 'rgba(0, 0, 0, 0.38)'
                        : 'rgba(0, 0, 0, 0.78)',
                      'font-size': '12px',
                      overflow: 'auto',
                    }"
                  >
                    {{ INT(item.org_level_all) }}</span
                  >
                </div>
                <!-- 自定义组列表 -->
                <div
                  style="
                    font-family: var(--body-font-family);
                    font-style: normal;
                    font-weight: normal;
                    font-size: 12px;
                    display: flex;
                    align-items: center;
                    color: rgba(0, 0, 0, 0.38);
                    flex: none;
                    order: 4;
                    align-self: center;
                  "
                  class="py-2"
                  v-if="checkedGroupList.length > 0"
                >
                  {{ $t("label_chooseStaff-tab-savedGroup") }}
                </div>
                <div
                  class="d-flex mt-1 pl-2 groupItem align-center gesture"
                  v-for="(item, index) in checkedGroupList"
                  :key="item.uuid + index"
                  @click.stop="tabs == 3 ? deleteItem(item, index) : ''"
                  style="
                    border: 1px solid #ececec;
                    height: 48px;
                    font-size: 14px;
                    border-radius: 4px;
                    justify-content: space-between;
                    align-items: center;
                  "
                  :class="item.active ? 'active' : ''"
                >
                  <span
                    :style="{
                      color: item.active ? '#0F46C1' : 'rgba(0, 0, 0, 0.78)',
                      'font-size': '14px',
                    }"
                  >
                    {{ INT(item.group_name) }}</span
                  >
                  <span
                    class="mr-2 bgd groupItemIcon"
                    @click.stop="findDetail(item)"
                    style="
                      width: 32px;
                      height: 32px;
                      border-radius: 50%;
                      align-items: center;
                      justify-content: center;
                    "
                  >
                    <v-icon
                      class="material-icons"
                      :disabled="true"
                      style="font-size: 18px"
                      >search</v-icon
                    >
                  </span>
                </div>
              </div>
            </div>
          </div>
          <!-- --------------------------组详情=----------------------------------------- -->
          <div v-else class="pr-4 pt-3 pl-4">
            <div class="d-flex mb-3">
              <div @click="backList">
                <v-icon class="material-icons" style="color: #0f46c1">
                  arrow_back
                </v-icon>
                <span class="ml-2" style="font-size: 12px; color: #0f46c1">
                  {{ INT(detailGroupName) }}</span
                >
              </div>
            </div>
            <div class="pt-2 mb-4 pb-2" style="border: 1px solid #ececec">
              <div class="footer_box pl-3 pr-2">
                <!-- 员工 -->
                <!-- @click.stop="tabs==0?deleteItem(item,index):''" -->
                <div
                  class="d-flex mt-1 pl-2 pt-1"
                  v-for="(item, index) in detailGroupList"
                  :key="item + index"
                  style="
                    border: 1px solid #ececec;
                    height: 48px;
                    font-size: 14px;
                    border-radius: 4px;
                  "
                  :class="item.active ? 'active' : ''"
                >
                  <div class="ml-2">
                    <v-img
                      style="border-radius: 50%"
                      height="24"
                      width="24"
                      :src="`https://picsum.photos/500/300?image=${5 * 5 + 10}`"
                      :lazy-src="`https://picsum.photos/10/6?image=${
                        5 * 5 + 10
                      }`"
                      class="grey lighten-2"
                    ></v-img>
                  </div>
                  <div class="d-flex ml-2" style="flex-direction: column">
                    <span
                      :style="{
                        color: item.active ? '#0F46C1' : 'rgba(0, 0, 0, 0.78)',
                        'font-size': '14px',
                      }"
                    >
                      {{ item.christian_name ? item.christian_name : "" }}
                      {{ item.christian_name && item.show_name ? "/" : "" }}
                      {{
                        item.show_name ? INT(item.show_name) : item.show_name
                      }}
                    </span>
                    <span
                      :style="{
                        color: item.active ? '#739CE8' : 'rgba(0, 0, 0, 0.38)',
                        'font-size': '12px',
                      }"
                    >
                      {{ INT(item.post_and_grade) }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          style="flex: 1; min-height: 500px"
          class="d-flex align-center justify-content-center"
          v-else
        >
          <v-progress-circular
            indeterminate
            style="margin: 0 auto"
            :size="70"
            :width="7"
            color="primary"
          ></v-progress-circular>
        </div>
      </div>
      <mrc_ess_myDialog
        title="newItem"
        :hiddenTitle="true"
        width="360"
        successText="ok"
        :disabled="false"
        :noPadding="false"
        v-model="dialog2"
      >
        <div class="groupBox">
          <div class="pl-8 pr-8 pt-8">
            <!--  -->
            <mrc_ess_input
              :label="$t('label_chooseStaff_groupName')"
              @input="inputGroup"
              :error-messages="$errors(null, 'addGroupName', requiredRule)"
              v-model="addGroupName"
            ></mrc_ess_input>
            <div
              v-if="showVerification"
              style="
                position: relative;
                top: -20px;
                color: #ff5252;
                font-size: 12px;
              "
            >
              {{ $t("vertify_chooseStaff-duplicatedGroup-tips") }}
            </div>
            <mrc_ess_submitBtn
              @success="successGroup"
              successText="ok"
              @cancel="
                () => {
                  dialog2 = false;
                }
              "
            ></mrc_ess_submitBtn>
          </div>
        </div>
      </mrc_ess_myDialog>
    </mrc_ess_myDialog>
  </div>
</template> 

<script>
/**
 * 需要修改请求方法
 */
import {
  required,
  maxLength,
  between,
  email,
  url,
} from "vuelidate/lib/validators";
// import { filter } from 'vuedraggable';
import {
  getChooseStaffTreeList,
  getStaffList,
  getPositionList,
  deleteGroup,
  addMyGroup,
  getDetailGroup,
  getSaveOrganization,
  addSaveOrganization,
  getGroupList,
} from "@/service/api/chooseStaff.js";
export default {
  components: {},
  props: {
    readonly: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "label",
    },
    uuid: {
      type: String,
      default: "",
    },
    itemText: {
      type: String,
      default: "org_level_name",
    },
    itemKey: {
      type: String,
      default: "uuid",
    },
  },
  model: {
    prop: "uuid",
    event: "change",
  },
  data() {
    return {
      loading: false,
      tabs: 0,
      dialog: false,
      dialog2: false,
      findGroupStatus: false,
      items: [
        "label_chooseStaff-tab-Staffs",
        "label_chooseStaff-tab-Organization",
        "label_chooseStaff-tab-Position",
        "label_chooseStaff-tab-savedGroup",
      ],
      selectStaffNum: 0,
      cardLoading: false,
      delCardLoading: false,
      treeList: [], //树结构
      viewAllList: [], //页面视图展示列表
      addViewList: [],
      orgTreeList: [], //组织架构树
      staffList: [], //请求的员工列表
      groupList: [], //返回的组列表
      positionList: [], //返回的岗位列表
      TsList: [], //暂存的list
      checkedStaffList: [], //用户选中的员工列表
      checkedOrgList: [], //用户选中的组织架构列表
      TsCheckedOrgList: [], //暂存组织架构列表
      checkedPositionList: [], //用户选中的岗位列表
      checkedGroupList: [], //用户选择的自定义组列表,
      detailGroupList: [],
      detailGroupName: "",
      addGroupName: "",
      showVerification: false,
      allList: [], //新增保存未保存的结果
    };
  },
  computed: {
    // groupStaffList () {
    //   return this.detailGroupList.filter(item => {
    //     return item.type == '1'
    //   })
    // },
    // groupOrgList () {
    //   return this.detailGroupList.filter(item => {
    //     return item.type == '2'
    //   })
    // },
    // groupPositionList () {
    //   return this.detailGroupList.filter(item => {
    //     return item.type == '3'
    //   })
    // },
    allListLength() {
      return Number(
        this.checkedStaffList.length +
          this.checkedOrgList.length +
          this.checkedPositionList.length +
          this.checkedGroupList.length
      );
    },
    checkedAllList() {
      //用户选中的总列表
      // this.checkedOrgList = this.checkedOrgList.map(item => {
      //   item.type = '2'
      //   return item
      // })
      let arr = [];
      this.checkedStaffList.map((item) => {
        arr.push({
          organization_names: this.INT(item.show_name),
          organization_types: "1",
          organization_uuids: item.uuid,
        });
      });
      this.checkedOrgList.map((item) => {
        arr.push({
          organization_names: this.INT(item.org_level_name),
          organization_types: "2",
          organization_uuids: item.uuid,
        });
      });
      this.checkedPositionList.map((item) => {
        arr.push({
          organization_names: this.INT(item.job_post_name),
          organization_types: "3",
          organization_uuids: item.uuid,
        });
      });
      this.checkedGroupList.map((item) => {
        arr.push({
          organization_names: this.INT(item.group_name),
          organization_types: String(item.group_type),
          organization_uuids: item.uuid,
        });
      });
      return arr;
      // return [...this.checkedStaffList, ...this.checkedOrgList, ...this.checkedPositionList, ...this.checkedGroupList]
    },
    allListComplete() {
      //用户选中的总列表
      let arr = [];
      this.checkedStaffList.map((item) => {
        arr.push(item);
      });
      this.checkedOrgList.map((item) => {
        arr.push(item);
      });
      this.checkedPositionList.map((item) => {
        arr.push(item);
      });
      this.checkedGroupList.map((item) => {
        arr.push(item);
      });
      return arr;
    },
  },
  created() {},
  watch: {
    async uuid(v) {
      await this.getOrgList(v);
    },
  },
  async mounted() {
    if (this.uuid) {
      await this.getOrgList(this.uuid);
    } else {
    }
  },
  methods: {
    returnText(val) {
      let str = [];
      val.forEach((item) => {
        str.push(this.INT(item.organization_names));
      });
      return str.join(",");
    },
    async getOrgList(val) {
      if (!val) return;
      //获取组织架构的详细信息
      let arr = [];
      this.checkedStaffList = [];
      this.checkedOrgList = [];
      this.checkedPositionList = [];
      this.checkedGroupList = [];
      if (!Array.isArray(val)) {
        const res = await getSaveOrganization({ uuid: val });
        if (res.code == 200) {
          res.data.map((item) => {
            if (item.type == 1) {
              arr.push({
                organization_names: this.INT(item.show_name),
                organization_types: "1",
                organization_uuids: item.uuid,
              });
              this.checkedStaffList.push({ ...item, active: true });
            }
            if (item.type == 2) {
              arr.push({
                organization_names: this.INT(item.org_level_name),
                organization_types: "2",
                organization_uuids: item.uuid,
              });
              this.checkedOrgList.push({ ...item, active: true });
            }
            if (item.type == 3) {
              arr.push({
                organization_names: this.INT(item.job_post_name),
                organization_types: "3",
                organization_uuids: item.uuid,
              });
              this.checkedPositionList.push({ ...item, active: true });
            }
            if (item.type == 4 || item.group_type == 4) {
              arr.push({
                organization_names: this.INT(item.name),
                organization_types: item.type,
                organization_uuids: item.uuid,
              });
              this.checkedGroupList.push({ ...item, active: true });
            }
            if (item.type == 5 || item.group_type == 5) {
              arr.push({
                organization_names: this.INT(item.group_name),
                organization_types: item.type,
                organization_uuids: item.uuid,
              });
              this.checkedGroupList.push({ ...item, active: true });
            }
          });
          this.viewAllList = arr;
        }
      } else {
        val.map((item) => {
          if (item.type == 1) {
            this.checkedStaffList.push({ ...item, active: true });
          }
          if (item.type == 2) {
            this.checkedOrgList.push({ ...item, active: true });
          }
          if (item.type == 3) {
            this.checkedPositionList.push({ ...item, active: true });
          }
          if (item.type == 4 || item.group_type == 4) {
            this.checkedGroupList.push({ ...item, active: true });
          }
          if (item.type == 5 || item.group_type == 5) {
            this.checkedGroupList.push({ ...item, active: true });
          }
        });
      }
    },
    async changeTabs(val) {
      //切换选项卡  请求树or列表
      if (val == 0) {
        //staff
        if (!this.treeList.length > 0) {
          const res = await getChooseStaffTreeList({
            uuid: this.$store.state.currentCompany,
          });
          if (res.code == 200) {
            if (!res.data) return (this.treeList = []);
            this.treeList = [{ ...res.data }];
          } else {
            this.$Message({ text: res.msg, color: "rgba(0,0,0,0.78)" });
          }
        }
      }
      if (val == 1) {
        //org
        if (!this.orgTreeList.length > 0) {
          this.cardLoading = true;
          const res = await getChooseStaffTreeList({
            uuid: this.$store.state.currentCompany,
          });
          if (res.code == 200) {
            if (!res.data) return (this.orgTreeList = []);
            this.orgTreeList = [{ ...res.data }];
            this.changeItemTreeActice(this.orgTreeList);
            this.checkedOrgList.map((item) => {
              //---执行子组件方法
              this.recursionChangeActive(this.orgTreeList, item.uuid, true);
              this.changeReadonly(this.orgTreeList, item.uuid, true);
            });
          } else {
            this.$Message({ text: res.msg, color: "rgba(0,0,0,0.78)" });
          }
          this.cardLoading = false;
          // this.changeItemTreeActice(this.orgTreeList)
        }
      }
      if (val == 2) {
        //position
        if (!this.treeList.length > 0) {
          const res = await getChooseStaffTreeList({
            uuid: this.$store.state.currentCompany,
          });
          if (res.code == 200) {
            if (!res.data) return (this.treeList = []);
            this.treeList = [{ ...res.data }];
          } else {
            this.$Message({ text: res.msg, color: "rgba(0,0,0,0.78)" });
          }
        }
      }
      if (val == 3) {
        //group
        this.cardLoading = true;
        await this.getGroupList();
        this.cardLoading = false;
      }
    },
    async getGroupList() {
      //获取个人组和公司组的列表
      const res = await getGroupList({
        company_uuid: this.$store.state.currentCompany,
      });
      if (res.code == 200) {
        this.groupList = res.data.map((item) => {
          let isNO = true;
          this.checkedGroupList.map((item1) => {
            if (item1.uuid == item.uuid) {
              isNO = false;
              return;
            }
          });
          if (isNO) {
            return { ...item, active: false };
          } else {
            return { ...item, active: true };
          }
        });
      }
    },
    async getStaffList(val) {
      //请求列表
      this.cardLoading = true;
      if (this.tabs == 0) {
        //发送请求。请求员工列表数据
        const res = await getStaffList({
          uuid: val.uuid,
        });
        if (res.code == 200) {
          this.staffList = res.data.map((item) => {
            //选中的给予状态
            item.type = "1";
            let isNo = true;
            this.checkedStaffList.map((item1) => {
              if (item1.uuid == item.uuid) {
                isNo = false;
                return;
              }
            });
            if (isNo) {
              return { ...item, active: false };
            } else {
              return { ...item, active: true };
            }
          });
        } else {
          this.$Message({ text: res.msg, color: "rgba(0,0,0,0.78)" });
        }
      }
      if (this.tabs == 1) {
        //获取组织uuid
      }
      if (this.tabs == 2) {
        //发送请求。请求Positon列表数据
        const res = await getPositionList({
          uuid: val.uuid,
        });
        if (res.code == 200) {
          this.positionList = res.data.map((item) => {
            item.type = 3;
            let isNo = true;
            this.checkedPositionList.map((item1) => {
              if (item1.uuid == item.uuid) {
                isNo = false;
                return;
              }
            });
            if (isNo) {
              return { ...item, active: false };
            } else {
              return { ...item, active: true };
            }
          });
        }
      }
      if (this.tabs == 3) {
        // await this.getGroupList()
      }
      this.cardLoading = false;
    },
    async detailStaff(val, index) {
      //点击员工||Positon||Group的每一项
      if (this.tabs == 0) {
        if (val.active == true) {
          this.checkedStaffList.map((item, index1) => {
            if (item.uuid == val.uuid) {
              this.checkedStaffList.splice(index1, 1);
            }
          });
        }
        val.active = !val.active;
        this.$set(this.staffList, index, val);
        const res = this.staffList.filter((item) => {
          return item.active == true;
        });
        this.checkedStaffList.push(...this.$clone(res));
        this.checkedStaffList = this.ArrayToHeavy(this.checkedStaffList);
      }
      if (this.tabs == 1) {
      }
      if (this.tabs == 2) {
        if (val.active == true) {
          this.checkedPositionList.map((item, index1) => {
            if (item.uuid == val.uuid) {
              this.checkedPositionList.splice(index1, 1);
            }
          });
        }
        val.active = !val.active;
        this.$set(this.positionList, index, val);
        const res = this.positionList.filter((item) => {
          return item.active == true;
        });
        this.checkedPositionList.push(...this.$clone(res));
        this.checkedPositionList = this.ArrayToHeavy(this.checkedPositionList);
      }
      if (this.tabs == 3) {
        //group
        let id = null;
        this.groupList.map((item, index1) => {
          if (item.uuid == val.uuid) {
            id = index1;
          }
        });
        if (val.active == true) {
          this.checkedGroupList.map((item, index1) => {
            if (item.uuid == val.uuid) {
              this.checkedGroupList.splice(index1, 1);
            }
          });
        }
        val.active = !val.active;
        this.$set(this.groupList, id, val);
        const res = this.groupList.filter((item) => {
          return item.active == true;
        });
        this.checkedGroupList.push(...this.$clone(res));
        this.checkedGroupList = this.ArrayToHeavy(this.checkedGroupList);
      }
    },
    selectAll(val, val2) {
      //选择列表中的全部员工  根据val2判断是全选还是全不选
      val = val.map((item) => {
        item.active = !val2;
        return item;
      });
      if (this.tabs == 0) {
        this.staffList = val;
        if (val2) {
          this.staffList.map((item, index) => {
            this.checkedStaffList.map((item1, index1) => {
              if (item.uuid == item1.uuid) {
                this.checkedStaffList.splice(index1, 1);
              }
            });
          });
        } else {
          this.checkedStaffList.push(...this.$clone(val));
        }
        this.checkedStaffList = this.ArrayToHeavy(this.checkedStaffList);
      }
      if (this.tabs == 1) {
      }
      if (this.tabs == 2) {
        this.positionList = val;
        if (val2) {
          this.positionList.map((item, index) => {
            this.checkedPositionList.map((item1, index1) => {
              if (item.uuid == item1.uuid) {
                this.checkedPositionList.splice(index1, 1);
              }
            });
          });
        } else {
          this.checkedPositionList.push(...this.$clone(val));
        }
        this.checkedPositionList = this.ArrayToHeavy(this.checkedPositionList);
      }
      if (this.tabs == 3) {
        this.groupList = val;
        if (val2) {
          this.groupList.map((item, index) => {
            this.checkedGroupList.map((item1, index1) => {
              if (item.uuid == item1.uuid) {
                this.checkedGroupList.splice(index1, 1);
              }
            });
          });
        } else {
          this.checkedGroupList.push(...this.$clone(val));
        }
        this.checkedGroupList = this.ArrayToHeavy(this.checkedGroupList);
      }
    },
    deleteItem(item, index) {
      //右边删除点击项 右边显示点击添加状态
      if (this.tabs == 0) {
        //staff
        this.checkedStaffList.splice(index, 1);
        this.staffList.map((item1, index1) => {
          if (item1.uuid == item.uuid) {
            this.$set(this.staffList, index1, { ...item1, active: false });
          }
        });
      }
      if (this.tabs == 1) {
        //org
        this.checkedOrgList.splice(index, 1);
        this.recursionChangeActive(this.orgTreeList, item.uuid, false);
        this.changeReadonly(this.orgTreeList, item.uuid);
      }
      if (this.tabs == 2) {
        //岗位
        this.checkedPositionList.splice(index, 1);
        this.positionList.map((item1, index1) => {
          if (item1.uuid == item.uuid) {
            this.$set(this.positionList, index1, { ...item1, active: false });
          }
        });
      }
      if (this.tabs == 3) {
        //group
        this.checkedGroupList.splice(index, 1);
        this.groupList.map((item1, index1) => {
          if (item1.uuid == item.uuid) {
            this.$set(this.groupList, index1, { ...item1, active: false });
          }
        });
      }
    },
    // -------------------------org的方法----------------------------
    recursionChangeActive(arr, uuid, status) {
      //递归调用改变点击项的状态
      arr.map((item, index) => {
        if (item.uuid == uuid) {
          this.$set(arr, index, { ...item, active: status });
          if (item.children && item.children.length > 0) {
            this.recursionActive(item.children, status);
          }
        }
        if (item.children && item.children.length > 0) {
          this.recursionChangeActive(item.children, uuid, status);
        }
      });
    },
    recursionActive(arr, val) {
      //递归将子节点变为 父节点的状态
      arr.map((item, index) => {
        this.$set(arr, index, { ...item, active: val });
        if (item.children && item.children.length > 0) {
          this.recursionActive(item.children, val);
        }
      });
    },
    changeReadonly(arr, uuid) {
      //递归改变当前节点 是否只读状态
      arr.map((item, index) => {
        if (item.uuid == uuid) {
          if (item.children && item.children.length > 0) {
            this.recursionReadonly(item.children, item.active);
          } else {
            // this.$set(arr, index, { ...item, active: !item.active })
          }
        } else {
          if (item.children && item.children.length > 0) {
            this.changeReadonly(item.children, uuid);
          }
        }
      });
    },
    recursionReadonly(arr, val) {
      //递归将子节点变为 变为父节点的禁用状态
      arr.map((item, index) => {
        this.$set(arr, index, { ...item, readonly: val });
        if (item.children && item.children.length > 0) {
          this.recursionReadonly(item.children, val);
        }
      });
    },
    changeItemTreeActice(val) {
      //改变树状态
      val.map((item) => {
        item.type = "2";
        item.active = false;
        item.readonly = false;
        if (item.children && item.children.length > 0) {
          this.changeItemTreeActice(item.children);
        }
      });
    },
    filterTree(val) {
      //递归选择符合条件的树
      val.map((item) => {
        if (item.active) {
          this.TsCheckedOrgList.push(item);
        } else {
          if (item.children && item.children.length > 0) {
            this.filterTree(item.children);
          }
        }
      });
    },
    changeAllList(val) {
      //org
      this.TsCheckedOrgList = [];
      this.filterTree(val);
      this.checkedOrgList = this.TsCheckedOrgList;
    },
    getDetail(val) {
      //获取当前点击树的一项  orgs
    },
    // -------------组------------------
    async findDetail(val) {
      //查看组的详情 发送请求
      this.findGroupStatus = true;
      this.detailGroupName = val.group_name;
      const res = await getDetailGroup({
        uuid: val.uuid,
      });
      if (res.code == 200) {
        this.detailGroupList = res.data;
      }
    },
    backList() {
      this.findGroupStatus = false;
    },
    // --------------------其他方法--------------------------
    ArrayToHeavy(arr) {
      //数组对象去重
      let object = {};
      let newArr = [];
      newArr = arr.reduce((item, next) => {
        object[next.uuid] ? "" : (object[next.uuid] = true && item.push(next));
        return item;
      }, []);
      return newArr;
    },
    flag() {
      this.tabs = 0;
      this.orgTreeList = [];
      this.staffList = [];
      this.groupList = [];
      this.positionList = [];
    },
    cancel() {
      this.tabs = 0;
      this.orgTreeList = [];
      this.staffList = [];
      this.groupList = [];
      this.positionList = [];
      this.dialog = false;
      this.$emit("cancel");
    },
    async success() {
      //总提交
      if (this.uuid) {
        //修改
        this.viewAllList = this.checkedAllList;
        this.$emit("success", this.checkedAllList);
        this.dialog = false;
        // 测试uuid 5ec43624-6ced-4f13-a77d-10ac1914ebc7
        const res = await addSaveOrganization({
          uuid: this.uuid,
          organizational_sub: this.checkedAllList,
        });
        if (res.code == 200 && res.data && res.data.uuid) {
          this.getOrgList(this.uuid);
          this.dialog = false;
        } else {
          if (res.data)
            this.$emit("change", res.data.uuid ? res.data.uuid : "");
          this.$Message({ text: res.msg, color: "rgba(0,0,0,0.78)" });
        }
      } else {
        //新增
        this.allList = this.allListComplete;
        this.addViewList = this.checkedAllList;
        this.$emit("success", this.checkedAllList);
        this.dialog = false;
        const res = await addSaveOrganization({
          organizational_sub: this.checkedAllList,
        });
        if (res.code == 200) {
          this.$emit("change", res.data.uuid);
          this.dialog = false;
        }
      }
    },
    async openDialog() {
      this.loading = true;
      this.dialog = true;
      this.changeTabs(0);
      if (this.uuid) {
        await this.getOrgList(this.uuid);
      } else {
        this.getOrgList(this.allList);
      }
      this.loading = false;
    },
    saveGroup() {
      if (this.allListLength > 0) {
        this.dialog2 = true;
      }
    },
    async successGroup() {
      //保存自己建的组   需替换请求
      this.$v.addGroupName.$touch();
      if (this.$v.addGroupName.$error) return;
      this.$emit("successGroup", this.checkedAllList);
      const res = await addMyGroup({
        group_type: "4",
        mrbase_sys_group_sub: this.checkedAllList,
        group_name: this.addGroupName,
      });
      if (res.code == 200) {
        this.$Message({ text: res.msg });
        await this.getGroupList();
      } else {
        this.$Message({ text: res.msg, color: "rgba(0,0,0,0.78)" });
      }
      this.dialog2 = false;
    },
    deleteGroup(val) {
      //删除个人组
      this.$myConfirm({
        content: this.$t("message_chooseStaff-delete-savedGroup-tips"),
      })
        .then(async (resss) => {
          this.delCardLoading = true;
          let arr = [];
          val.map((item) => {
            arr.push(item.uuid);
          });
          const res = await deleteGroup({
            uuids: arr.join(),
          });
          if (res.code == 200) {
            await this.getGroupList();
            this.$refs.groupRef.deleteStatus = false;
          } else {
            this.$Message({ text: err.msg, color: "rgba(0,0,0,0.78)" });
          }
          this.delCardLoading = false;
        })
        .catch((err) => {});
    },
    async inputGroup(v) {
      //验证组名是否重复
      if (!v) return (this.showVerification = false);
      if (!this.groupList.length > 0) {
        await this.getGroupList();
      }
      if (
        this.groupList.some((item) => {
          return item.group_name == v && item.group_type == "4";
        })
      ) {
        this.showVerification = true;
      } else {
        this.showVerification = false;
      }
    },
  },
  validations: {
    addGroupName: {
      required,
    },
  },
};
</script>

<style scoped>
.spans {
  max-width: 30vw;
  word-break: keep-all;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.footer_box {
  height: 446px;
  overflow-y: auto;
}
.dv /deep/ .v-slide-group__prev {
  min-width: 0;
  flex: none;
}
.dv /deep/ .v-tab {
  min-width: initial;
  font-size: 12px;
  font-family: var(--body-font-family);
  font-style: normal;
  font-weight: normal;
  color: rgba(0, 0, 0, 0.78);
  padding: 0;
  letter-spacing: initial;
}
.segmentation {
  /* border: 3px solid #ececec; */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.segmentation2 {
  border: 2px solid #e0e0e0;
}
.active {
  background-color: #e5eeff;
  border: 1px solid #c6dbfd;
}
.groupBox /deep/ .btnGroup {
  background-color: #ffffff !important;
  justify-content: flex-end !important;
  padding: 0 !important;
}
.groupBox /deep/ .successBtn {
  margin: 0 !important;
}
.tabactive {
  border-bottom: 4px solid #0f46c1;
}
.dv /deep/ .v-card__title {
  padding: 8px 16px;
}
.groupItemIcon {
  display: none;
}
.groupItem:hover .groupItemIcon {
  display: flex;
  background-color: rgba(0, 0, 0, 0.1);
}
.gesture:hover {
  cursor: pointer;
}

.v-input--selection-controls {
  margin: 0;
  padding: 0;
}
/deep/ .v-select__slot {
  min-height: 40px;
}
/deep/ .v-select__selections {
  min-height: 40px;
  padding-left: 8px;
}
/deep/ .v-list-item {
  min-height: 40px !important;
  padding: 0;
}
/deep/ .v-list-item__content {
  min-height: 40px !important;
  /* max-height: 48px !important; */
  /* padding: 7px 0; */
}
.overflow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.bigBox /deep/.v-input .v-label {
  top: 2px !important;
  /* left: -5px !important; */
}
/deep/ .v-input__append-inner {
  margin-top: 8px;
  margin-right: 8px;
}
.v-application--is-ltr .v-text-field .v-input__prepend-inner {
  padding: 0 !important;
}
</style>
